var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 4,
    viewBox: "0 0 18 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 2C10.875 3.03516 10.0352 3.875 9 3.875C7.96484 3.875 7.125 3.03516 7.125 2C7.125 0.964844 7.96484 0.125 9 0.125C10.0352 0.125 10.875 0.964844 10.875 2ZM15.5625 0.125C14.5273 0.125 13.6875 0.964844 13.6875 2C13.6875 3.03516 14.5273 3.875 15.5625 3.875C16.5977 3.875 17.4375 3.03516 17.4375 2C17.4375 0.964844 16.5977 0.125 15.5625 0.125ZM2.4375 0.125C1.40234 0.125 0.5625 0.964844 0.5625 2C0.5625 3.03516 1.40234 3.875 2.4375 3.875C3.47266 3.875 4.3125 3.03516 4.3125 2C4.3125 0.964844 3.47266 0.125 2.4375 0.125Z",
    fill: "#335C75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreDots);
export default __webpack_public_path__ + "static/media/MoreDots.8b9d3789d4e12d3bc6a4954dae0dabe0.svg";
export { ForwardRef as ReactComponent };